(function () {
  const root = document.getElementById("explore-aggregator");
  if (!root) return;

  const grid = document.getElementById("ea-grid");
  const pagination = document.getElementById("ea-pagination");
  const searchInput = document.getElementById("ea-search");
  const searchBtn = document.getElementById("ea-search-btn");
  const tabsEl = document.getElementById("ea-tabs");

  let tabs = [];
  try {
    tabs = JSON.parse(root.dataset.tabs || "[]");
  } catch (_) {
    tabs = [];
  }

  const state = {
    q: "",
    category: "All",
    page: 1,
    perPage: parseInt(root.dataset.perPage || "9", 10),
    tabs,
  };

  const dataCache = new Map();
  let currentController = null;

  const truncate = (str, n) =>
    !str ? "" : str.length > n ? str.slice(0, n - 1) + "…" : str;

  function normalizeUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      return u.pathname.replace(/\/$/, "").toLowerCase();
    } catch {
      return String(url).replace(/\/$/, "").toLowerCase();
    }
  }

  function dedupeItems(items) {
    const map = new Map();
    items.forEach((it) => {
      if (!it || !it.url) return;
      const key = normalizeUrl(it.url);
      if (!map.has(key)) map.set(key, it);
    });
    return Array.from(map.values());
  }

  function scrollToTop() {
    const headerOffset = parseInt(root.dataset.scrollOffset || "0", 10);
    const top =
      root.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    try {
      window.scrollTo({ top, behavior: "smooth" });
    } catch (_) {
      window.scrollTo(0, top);
    }
  }

  // === Helpers ===
  function estimateReadTime(text) {
    const words = String(text || "")
      .replace(/\s+/g, " ")
      .trim()
      .split(" ")
      .filter(Boolean).length;

    const mins = Math.max(1, Math.ceil(words / 200));
    return `${mins} min read`;
  }

  function getCategories(raw) {
    if (!raw) return [];
    let value = raw;

    if (Array.isArray(value)) {
      return value.map((t) => String(t).trim()).filter(Boolean);
    }

    if (typeof value === "string") {
      const trimmed = value.trim();

      // JSON array string
      if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed.map((t) => String(t).trim()).filter(Boolean);
          }
        } catch (_) {}
      }

      // "A,B,C"
      return trimmed
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
    }

    return [String(value).trim()].filter(Boolean);
  }

  function formatOverlayDate(item) {
    const raw = item?.published_at || item?.created_at || "";
    if (!raw) return "";

    const dt = new Date(raw);
    if (isNaN(dt.getTime())) return "";

    return dt.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  }

  function normalizeCategory(item) {
    if (
      item.type === "page" &&
      (item.not_articles === true || item.not_articles === "true")
    ) {
      return false;
    }

    if (state.category === "All") return true;
    const target = state.category.toLowerCase();

    const cats = getCategories(item.category).map((t) => t.toLowerCase());
    return cats.includes(target);
  }

  function deriveTabsFromItems(items) {
    const set = new Set(["All"]);
    items.forEach((it) => {
      getCategories(it.category).forEach((t) => t && set.add(t));
    });
    state.tabs = Array.from(set);
  }

  function renderTabs() {
    tabsEl.innerHTML = "";
    const list = state.tabs && state.tabs.length ? state.tabs : ["All"];
    list.forEach((raw) => {
      const label = String(raw || "").trim();
      const b = document.createElement("button");
      b.className = "ea-tab" + (label === state.category ? " active" : "");
      b.type = "button";
      b.textContent = label;
      b.addEventListener("click", () => {
        if (state.category === label) return;
        state.category = label;
        state.page = 1;
        renderFromCache();
        scrollToTop();
      });
      tabsEl.appendChild(b);
    });
  }

  function applyOverlayStyle(media, overlay) {
    const imp = (el, prop, val) => el.style.setProperty(prop, val, "important");

    const O = {
      inset: 0,
      padY: 12,
      padX: 16,
      radius: 16,
      bg: "rgba(0,0,0,.38)",
      blur: 5,
      fontSize: 12,
      lineHeight: 1.2,
      gap: 16,
      sep: "rgba(255,255,255,.18)",
    };

    // mobile tighten
    if (window.matchMedia && window.matchMedia("(max-width: 480px)").matches) {
      O.inset = 0;
      O.padY = 10;
      O.padX = 12;
      O.fontSize = 11;
      O.blur = 4;
      O.gap = 12;
    }

    imp(media, "position", "relative");
    imp(media, "display", "block");
    imp(media, "overflow", "hidden");
    imp(media, "border-radius", "0px");
    imp(overlay, "position", "absolute");
    imp(overlay, "left", `${O.inset}px`);
    imp(overlay, "right", `${O.inset}px`);
    imp(overlay, "bottom", `${O.inset}px`);
    imp(overlay, "display", "grid");
    imp(overlay, "grid-template-columns", "minmax(0,1fr) auto");
    imp(overlay, "align-items", "center");
    imp(overlay, "column-gap", `${O.gap}px`);
    imp(overlay, "padding", `${O.padY}px ${O.padX}px`);
    imp(overlay, "border-radius", `0px`);
    imp(overlay, "background", O.bg);
    imp(overlay, "-webkit-backdrop-filter", `blur(${O.blur}px)`);
    imp(overlay, "backdrop-filter", `blur(${O.blur}px)`);
    imp(overlay, "color", "#fff");
    imp(overlay, "font-size", `${O.fontSize}px`);
    imp(overlay, "line-height", String(O.lineHeight));

    const left = overlay.querySelector(".ea-overlay__left");
    if (left) {
      imp(left, "min-width", "0");
      imp(left, "display", "flex");
      imp(left, "flex-direction", "column");
    }

    [".ea-overlay__cat", ".ea-overlay__date", ".ea-overlay__time"].forEach(
      (sel) => {
        const el = overlay.querySelector(sel);
        if (!el) return;
        imp(el, "min-width", "0");
        imp(el, "white-space", "nowrap");
        imp(el, "overflow", "hidden");
        imp(el, "text-overflow", "ellipsis");
        imp(el, "word-break", "keep-all");
        imp(el, "overflow-wrap", "normal");
        imp(el, "hyphens", "none");
      },
    );

    const dateEl = overlay.querySelector(".ea-overlay__date");
    if (dateEl) {
      imp(dateEl, "margin-top", "4px");
      imp(dateEl, "opacity", "0.9");
    }

    const timeEl = overlay.querySelector(".ea-overlay__time");
    if (timeEl) {
      imp(timeEl, "font-weight", "600");
      imp(timeEl, "padding-left", "16px");
      imp(timeEl, "border-left", `1px solid ${O.sep}`);
    }
  }

  function renderCards(items) {
    grid.innerHTML = "";
    items.forEach((it) => {
      const cats = getCategories(it.category);
      const catLabel =
        cats[0] || (it.type === "article" ? "Itinerary" : "Page");

      const metaDesc =
        it.meta_description ||
        it.metaDescription ||
        it.seo_description ||
        it.description_tag ||
        "";

      const rt = it.read_time;
      const timeLabel =
        rt !== null && rt !== undefined && String(rt).trim() !== ""
          ? `${parseInt(rt, 10)} min read`
          : estimateReadTime(metaDesc || it.excerpt || "");

      const dateLabel = formatOverlayDate(it);

      const card = document.createElement("article");
      card.className = "ea-card";
      card.setAttribute("role", "link");
      card.setAttribute("tabindex", "0");

      card.addEventListener("click", (e) => {
        if (e.target.closest("a")) return;
        window.location.href = it.url;
      });
      card.addEventListener("keydown", (e) => {
        if (e.key === "Enter") window.location.href = it.url;
      });

      const media = document.createElement("a");
      media.href = it.url;
      media.className = "ea-media";

      if (it.image) {
        const img = document.createElement("img");
        img.src = it.image;
        img.alt = it.title || "";
        img.className = "ea-cover";
        img.loading = "lazy";
        img.decoding = "async";
        media.appendChild(img);
      } else {
        const ph = document.createElement("div");
        ph.className = "ea-cover";
        media.appendChild(ph);
      }

      const overlay = document.createElement("div");
      overlay.className = "ea-overlay";
      overlay.innerHTML = `
        <div class="ea-overlay__left">
          <span class="ea-overlay__cat">${catLabel}</span>
          ${dateLabel ? `<span class="ea-overlay__date">${dateLabel}</span>` : ""}
        </div>
        <span class="ea-overlay__time">${timeLabel}</span>
      `;

      applyOverlayStyle(media, overlay);
      media.appendChild(overlay);

      card.appendChild(media);

      const body = document.createElement("div");
      body.className = "ea-body";

      const title = document.createElement("h3");
      title.className = "ea-title";
      title.textContent = truncate(it.title, 52);
      body.appendChild(title);

      const desc = document.createElement("p");
      desc.className = "ea-desc";
      desc.textContent = truncate(metaDesc || it.excerpt || "", 120);
      body.appendChild(desc);

      card.appendChild(body);
      grid.appendChild(card);
    });
  }

  function renderPagination(total) {
    const pageCount = Math.max(1, Math.ceil(total / state.perPage));
    state.page = Math.min(Math.max(1, state.page), pageCount);
    const cur = state.page;

    pagination.innerHTML = "";

    const go = (page) => {
      state.page = page;
      renderFromCache();
      scrollToTop();
    };

    const addBtn = (label, page, { active = false, disabled = false } = {}) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className =
        "ea-page" + (active ? " active" : "") + (disabled ? " disabled" : "");
      b.textContent = String(label);
      if (!active && !disabled && page && page !== cur) {
        b.addEventListener("click", () => go(page));
      } else {
        b.disabled = true;
      }
      pagination.appendChild(b);
    };

    const addEllipsis = () => {
      const s = document.createElement("span");
      s.className = "ea-page ea-ellipsis";
      s.textContent = "…";
      pagination.appendChild(s);
    };

    addBtn("<<", 1, { disabled: cur <= 1 });
    addBtn("<", cur - 1, { disabled: cur <= 1 });

    if (pageCount <= 7) {
      for (let i = 1; i <= pageCount; i++) addBtn(i, i, { active: i === cur });
    } else if (cur <= 4) {
      for (let i = 1; i <= 4; i++) addBtn(i, i, { active: i === cur });
      addEllipsis();
      addBtn(pageCount, pageCount, { active: cur === pageCount });
    } else if (cur >= pageCount - 3) {
      addBtn(1, 1);
      addEllipsis();
      for (let i = pageCount - 3; i <= pageCount; i++)
        addBtn(i, i, { active: i === cur });
    } else {
      addBtn(1, 1);
      addEllipsis();
      [cur - 1, cur, cur + 1].forEach((i) =>
        addBtn(i, i, { active: i === cur }),
      );
      addEllipsis();
      addBtn(pageCount, pageCount);
    }

    addBtn(">", cur + 1, { disabled: cur >= pageCount });
    addBtn(">>", pageCount, { disabled: cur >= pageCount });
  }

  async function fetchAllData(force = false) {
    const key =
      state.q && state.q.trim() !== "" ? state.q.trim().toLowerCase() : "*";
    if (!force && dataCache.has(key)) return dataCache.get(key);

    if (currentController) currentController.abort();
    currentController = new AbortController();

    const base = new URLSearchParams();
    base.set("view", "ap-json");
    base.set("type", "article,page");
    base.set("q", key);
    base.set("page", "1");
    base.set("_", String(Date.now()));

    let res;
    try {
      res = await fetch(`/search?${base.toString()}`, {
        headers: { Accept: "application/json" },
        signal: currentController.signal,
      });
    } catch (_) {
      return { items: [], count: 0, ts: Date.now() };
    }
    if (!res.ok) return { items: [], count: 0, ts: Date.now() };

    let json1;
    try {
      json1 = await res.json();
    } catch (_) {
      json1 = { items: [], pages: 1, count: 0 };
    }

    let items = Array.isArray(json1.items) ? json1.items : [];
    let totalPages = Number(json1.pages || 1);

    if (!items.length && key === "*") {
      const alt = new URLSearchParams(base.toString());
      alt.delete("q");
      try {
        const r2 = await fetch(`/search?${alt.toString()}`, {
          headers: { Accept: "application/json" },
          signal: currentController.signal,
        });
        if (r2.ok) {
          const j2 = await r2.json();
          items = j2.items || items;
          totalPages = Number(j2.pages || totalPages);
          base.delete("q");
        }
      } catch (_) {}
    }

    const tasks = [];
    for (let p = 2; p <= totalPages; p++) {
      const params = new URLSearchParams(base.toString());
      params.set("page", String(p));
      tasks.push(
        fetch(`/search?${params.toString()}`, {
          headers: { Accept: "application/json" },
          signal: currentController.signal,
        })
          .then((r) => (r.ok ? r.json() : { items: [] }))
          .then((j) => j.items || [])
          .catch(() => []),
      );
    }

    if (tasks.length) {
      const rest = await Promise.allSettled(tasks);
      rest.forEach((pr) => {
        if (pr.status === "fulfilled" && pr.value && pr.value.length)
          items = items.concat(pr.value);
      });
    }

    items = dedupeItems(items);

    const payload = {
      items,
      count: items.length,
      ts: Date.now(),
    };

    dataCache.set(key, payload);
    return payload;
  }

  function renderFromCache() {
    const key =
      state.q && state.q.trim() !== "" ? state.q.trim().toLowerCase() : "*";
    const cached = dataCache.get(key);
    if (!cached) return;

    if (!state.tabs || state.tabs.length === 0)
      deriveTabsFromItems(cached.items);
    renderTabs();

    const base = cached.items.filter(normalizeCategory);
    const sorted = base
      .slice()
      .sort(
        (a, b) =>
          new Date(b.published_at || b.created_at || 0) -
          new Date(a.published_at || a.created_at || 0),
      );

    const start = (state.page - 1) * state.perPage;
    const paged = sorted.slice(start, start + state.perPage);

    renderCards(paged);
    renderPagination(sorted.length);

    const url = new URL(window.location.href);
    if (state.q) url.searchParams.set("q", state.q);
    else url.searchParams.delete("q");
    url.searchParams.set("cat", state.category);
    url.searchParams.set("p", String(state.page));
    history.replaceState(null, "", url.toString());
  }

  async function fetchAndRender(force = false) {
    const { items } = await fetchAllData(force);
    if (!state.tabs || state.tabs.length === 0) deriveTabsFromItems(items);
    renderFromCache();
  }

  let searchTimer = null;
  function triggerSearch() {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      state.page = 1;
      fetchAndRender(true);
      scrollToTop();
    }, 250);
  }

  searchBtn.addEventListener("click", () => {
    const newQ = (searchInput.value || "").trim();
    if (!newQ) {
      state.q = "";
      state.category = "All";
      state.page = 1;
      fetchAndRender(true);
      scrollToTop();
    } else {
      if (newQ === state.q) return;
      state.q = newQ;
      triggerSearch();
    }
  });

  searchInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      const newQ = (searchInput.value || "").trim();
      if (!newQ) {
        state.q = "";
        state.category = "All";
        state.page = 1;
        fetchAndRender(true);
        scrollToTop();
      } else {
        if (newQ === state.q) return;
        state.q = newQ;
        triggerSearch();
      }
    }
  });

  searchInput.addEventListener("input", () => {
    if (searchInput.value.trim() === "") {
      state.q = "";
      state.category = "All";
      state.page = 1;
      fetchAndRender(true);
    }
  });

  const url = new URL(window.location.href);
  const _q = url.searchParams.get("q");
  if (_q) {
    state.q = _q;
    searchInput.value = _q;
  }
  const _cat = url.searchParams.get("cat");
  if (_cat) state.category = _cat;

  const _p = parseInt(url.searchParams.get("p") || "1", 10);
  if (_p > 0) state.page = _p;

  fetchAndRender();
})();
